// src/flows/masterclass/ai/StepAI_Purpose.tsx
import { AIStepLayout } from './AIStepLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { useProgramCreation } from '../../ProgramCreationContext';
import { useState } from 'react';
import { API } from '../../../../../api';
import DosenInput from '../../../../../pages/new-designs/components/DosenInput';
import { useAppSelector } from '../../../../../redux/hooks';


interface StepAI_PurposeProps {
  model?: string;
  minDescriptionLength?: number;
}

export function StepAI_Purpose({ model = 'masterclass', minDescriptionLength = 200 }: StepAI_PurposeProps) {
  const navigate = useNavigate();
  const { state, dispatch } = useProgramCreation();
  const { id: grpId = '', coId: coIdParam, orgId: orgIdParam } = useParams();
  const orgIdParamNew = useAppSelector((state) => state.orgDetails.data?._id) || '';
  const parentIdParamNew = useAppSelector((state) => state.orgDetails.data?.grpId) || '';

  const [name, setName] = useState(state.ai.purpose.name);
  const [description, setDescription] = useState(state.ai.purpose.description);
  const [isCreatingInitialIds, setIsCreatingInitialIds] = useState(false);

  const trimmedDescriptionLength = description.trim().length;
  const valid = name.trim().length > 0 && trimmedDescriptionLength > minDescriptionLength;
  const createProgramInitialIds = async () => {
    let newGroupId = state.groupId;

    if (!newGroupId) {
      const groupRes = await API.createGroup({
        orgId: orgIdParamNew,
        name: name,
        parent: parentIdParamNew
      });

      newGroupId = groupRes.data.groupDetails.grpId;

      const formData = new FormData();
      formData.append('model', model);
      formData.append('includeTask', 'true');
      formData.append('allowEditing', 'false');
      formData.append('mentee', 'mentee');
      formData.append('mentor', 'mentor');

      await API.updateGroupInfo({
        orgId: coIdParam ?? '',
        grpId: newGroupId ?? '',
        formData
      });

      dispatch({ type: 'SET_GROUP_ID', payload: newGroupId ?? '' });
    }

    if (!state.generationId && newGroupId) {
      const genRes = await API.generateProgramId({
        groupId: newGroupId
      });

      dispatch({ type: 'SET_GENERATION_ID', payload: genRes.data.id });
    }
  };

  const handleNext = async () => {
    if (isCreatingInitialIds) return;
    setIsCreatingInitialIds(true);
    try {
      await createProgramInitialIds();
    } finally {
      setIsCreatingInitialIds(false);
    }
    dispatch({ type: 'UPDATE_AI_PURPOSE', payload: { name, description } });
    dispatch({ type: 'UPDATE_MASTERCLASS', payload: { title: name, description } });
    dispatch({ type: 'SET_AI_STEP', payload: 3 });
    navigate('../objectives');
  };

  return (
    <AIStepLayout
      stepTitle="Purpose"
      title="General Purpose"
      onBack={() => navigate(-1)}
      onNext={handleNext}
      nextDisabled={!valid}
      nextLoading={isCreatingInitialIds}
    >
      <DosenInput label="Program Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth />

      <DosenInput
        label="Program Purpose"
        multiline
        rows={5}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        minChars={minDescriptionLength}
        fullWidth
      />
    </AIStepLayout>
  );
}
